import React from 'react';
import { Text, Image, Button } from 'components/ui';
import ApplePay from 'services/ApplePay';
import LanguageLocale from 'utils/LanguageLocale';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import EN from 'components/ApplePayButton/locales/ApplePayButton_en_US.js';
import FR from 'components/ApplePayButton/locales/ApplePayButton_fr_CA.js';

//Analytics
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

const { getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(EN, FR);

const iconOnlySize = {
    src: '/img/ufe/rwd-basket/apple-pay-logo.svg',
    width: 59,
    height: 'auto'
};

const iconAndTextSize = {
    src: '/img/ufe/logo-apple-pay.svg',
    width: 42,
    height: 20
};

const applePayButtonStyle = {
    paddingLeft: 0,
    paddingRight: 0,
    border: 0
};

class ApplePayButton extends BaseClass {
    state = {};

    onClick = e => {
        e.stopPropagation();
        e.preventDefault();

        //Analytics
        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: {
                linkName: 'checkout:payment:applepay',
                actionInfo: 'checkout:payment:applepay',
                eventStrings: [anaConsts.Event.EVENT_71]
            }
        });

        ApplePay.onApplePayClicked(e);
    };

    render() {
        const { isApplePayPayment, iconOnly = false, ...props } = this.props;

        const isDisabled = isApplePayPayment === ApplePay.TYPES.DISABLED;

        const iconSize = iconOnly ? iconOnlySize : iconAndTextSize;

        return isApplePayPayment !== ApplePay.TYPES.HIDDEN ? (
            <Button
                variant='primary'
                onClick={this.onClick}
                disabled={isDisabled}
                {...props}
                css={applePayButtonStyle}
            >
                <React.Fragment>
                    {iconOnly ? null : (
                        <Text
                            marginRight={2}
                            fontWeight='normal'
                        >
                            {getText('checkoutWith')}
                        </Text>
                    )}
                    <Image
                        disableLazyLoad={true}
                        alt='Apple Pay'
                        src={iconSize.src}
                        width={iconSize.width}
                        height={iconSize.height}
                        maxHeight='100%'
                        css={{ objectFit: 'contain' }}
                    />
                </React.Fragment>
            </Button>
        ) : (
            <div></div>
        );
    }
}

export default wrapComponent(ApplePayButton, 'ApplePayButton', true);
